import React, {SyntheticEvent, useEffect} from "react";
import NumberFormat, {InputAttributes} from 'react-number-format';
import {TextField} from "@mui/material";

interface CustomProps {
  onChange: (event: { target: { name: string; value: string } }) => void;
  name: string;
}

type EventHandler = (evt:SyntheticEvent) => void;

export function NumberField(props)  {
  const variant = props.fill?'filled':'filled';
  return <TextField
      variant={variant}
      {...props}
      multiline={false}
      InputLabelProps={{ shrink: true }}
      InputProps={{
        inputComponent: NumberFormatCustom as any,
      }}
      inputProps={{
        autoSize:true
      }
      }
  />
}


const NumberFormatCustom = React.forwardRef<
    NumberFormat<InputAttributes>,
    CustomProps
    >(function NumberInputRef(props:{
  name: string,
  value: number,
  autoFocus: boolean,
  onChange: Function,
  onBlur?: EventHandler,
  className?: string,
  loading?:boolean,
  readOnly?: boolean,
  autoSize?:boolean
},ref) {
  const localRef = React.useRef(null);
  const doChange = (value)=>{
    console.log('bubbleup changes',value);
    props.onChange({target:{name:props.name,value:value.floatValue},currentTarget:{name:props.name,value:value.floatValue}});
  }
  useEffect(()=>{
    if(props.autoSize && localRef?.current) {
      localRef.current.size =2;
    }
  },[props.autoSize,localRef.current,props.value?.length]);
  React.useImperativeHandle(ref, () => localRef.current);
  return <NumberFormat
      getInputRef={localRef}
      name={props.name}
      isNumericString={false}
      fullWidth={true}
      style={{textAlign:'right',paddingRight:'4px'}}
      className={[(props.className??'')].join(' ')}
      value={props.value}
      onValueChange={doChange}
      autoFocus={props.autoFocus}
      onBlur={props.onBlur}
      onFocus={(evt)=>{ evt.target.select() }}
      readOnly={props.readOnly}
  />;
});


const NumberInput = (props:{
  name: string,
  value: number,
  autoFocus: boolean,
  onChange: Function,
  onBlur?: EventHandler,
  className?: string,
  loading?:boolean,
  readOnly?: boolean
}) => {
  const doChange = (value)=>{
    console.log('bubbleup changes',value);
    props.onChange({target:{name:props.name,value:value.floatValue},currentTarget:{name:props.name,value:value.floatValue}});
  }
  return <NumberFormat
    name={props.name}
    isNumericString={false}
    className={[(props.className??'')].join(' ')}
    value={props.value}
    onValueChange={doChange}
    autoFocus={props.autoFocus}
    onFocus={(evt)=>{ evt.target.select()}}
    onBlur={props.onBlur}
    readOnly={props.readOnly}
  />;
}

export default NumberInput;
